import { Badge, BadgeProps } from "@chakra-ui/react";
import * as React from "react";

interface EwcCodeUpdatedBadgeProps extends BadgeProps {
  invoicedCode?: string | null;
}

/**
 * Marks an invoiced collection note (or line) whose EWC code has been corrected since it was
 * invoiced, so the invoice may show a different code.
 */
export const EwcCodeUpdatedBadge: React.FC<EwcCodeUpdatedBadgeProps> = ({
  invoicedCode,
  ...props
}) => {
  return (
    <Badge
      borderRadius="full"
      px={2}
      py={1}
      colorScheme="purple"
      title={invoicedCode ? `Invoiced as ${invoicedCode}` : "EWC code updated since invoicing"}
      {...props}
    >
      Code updated
    </Badge>
  );
};
